module.exports = __webpack_public_path__ + "img/III-96.0f3709a8.svg";